import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { UserProfileData } from '../models/user-profile.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SharedService {
  constructor() {}

  public errorMessageSubject = new BehaviorSubject<string>('');
  public errorMessage$ = this.errorMessageSubject.asObservable();

  public showUIElementsSubject = new BehaviorSubject<boolean>(false);
  public showUIElements$ = this.showUIElementsSubject.asObservable();

  public userProfileSubject = new BehaviorSubject<UserProfileData | null>(null);
  public userProfile$ = this.userProfileSubject.asObservable();

  getAccessToken() {
    return sessionStorage.getItem('access_token') || '';
  }

  setShowUIElements(value: boolean) {
    this.showUIElementsSubject.next(value);
  }

  setUserProfile(value: UserProfileData) {
    this.userProfileSubject.next(value);
    sessionStorage.setItem('userProfile', JSON.stringify(value));
  }

  logger(identifier: string, data: any) {
    if (environment.currentEnvironment !== 'production') {
      console.log(
        `${environment.currentEnvironment} ------ ${identifier}`,
        '\n',
        JSON.stringify(data)
      );
    }
  }

  setErrorMessage(message: string) {
    this.errorMessageSubject.next(message);
  }

  clearStorage() {
    sessionStorage.clear();
  }

  getErrorMessage() {
    return this.errorMessage$;
  }
}
